module.exports = __webpack_public_path__ + "static/img/bancamia.5be5a231.svg";